import { useContext, useEffect, useState } from "react";
import { BannerProps, PromotionsProps } from "./constants";
import Image from "next/image";
import { CustomVariantItemProps, MinProductItemProps, ProductVariantItemProps } from "../Product/constants";
import CenterTemplate from "./CenterTemplate";
import NormalTemplate from "./NormalTemplate";
import Link from "next/link";
import Cookies from "js-cookie";
import AddToCart from "../Product/AddToCart";
import { GlobalContext, GlobalState } from "@/context/useGlobalContext";


const Promotions = (props: PromotionsProps) => {
  const { banner_list, promotion_list } = props;
  const viewport = Cookies.get('viewport') || "mobile";
  const { showCart, setShowCart } = useContext(GlobalContext) as GlobalState;
  const [mainBanner, setMainBanner] = useState<BannerProps | null>(null);
  const [multiBanner, setMultiBanner] = useState<Array<BannerProps>>([]);
  const [bottomBanner, setBottomBanner] = useState<Array<BannerProps>>([]);
  const [selectProduct, setSelectProduct] = useState<MinProductItemProps | null>(null);
  const [variant, setVariant] = useState<ProductVariantItemProps | null>(null);
  const [selectedCustomVariant, setSelectedCustomVariant] = useState<CustomVariantItemProps | null>(null);
  const [fromName, setFromName] = useState<string>('');
  const [toName, setToName] = useState<string>('');
  const [toEmail, setToEmail] = useState<string>('');
  const [toMobile, setToMobile] = useState<string>('');
  const [toMessage, setToMessage] = useState<string>('');
  const [pregnancy, setPregnancy] = useState<string>('');
  const [duDate, setDuDate] = useState<Date | null>(null);
  const [childName, setChildName] = useState<string>('');
  const [childAge, setChildAge] = useState<number | null>(null);
  const [childGender, setChildGender] = useState<string>('');
  const [open, setOpen] = useState(false);
  const [affiliate, setAffiliate] = useState<string | undefined>(undefined);

  useEffect(() => {
    const mainBanners = banner_list.filter((banner) => banner.position === "main");

    if (mainBanners.length > 0) {
      setMainBanner(mainBanners[0]);
    }

    const multiBanners = banner_list.filter((banner) => banner.position === "left" || banner.position === "right");

    if (multiBanners.length > 0) {
      setMultiBanner(multiBanners);
    }

    const bottomBanners = banner_list.filter((banner) => banner.position === "bottom");

    if (bottomBanners.length > 0) {
      setBottomBanner(bottomBanners);
    }

    if (window !== undefined) {
      setAffiliate(Cookies.get(window.btoa("affiliate")));
    }
  }, [banner_list]);

  useEffect(() => {
    if (selectProduct !== null && !open) {
      setOpen(true);
    }
  }, [selectProduct, open])

  useEffect(() => {
    if (!open) {
      setSelectProduct(null);
    }
  }, [open])

  return (
    <>
      {mainBanner && (
        <div className="w-full">
          <Link href={mainBanner.link}>
            <Image
              src={mainBanner.desktop_image}
              alt="Main Banner"
              width={1636}
              height={500}
              quality={100}
              className="hidden md:block w-full"
            />
            <Image
              src={mainBanner.mobile_image}
              alt="Main Banner"
              width={766}
              height={500}
              quality={100}
              className="block md:hidden w-full"
            />
          </Link>
        </div>
      )}
      {promotion_list.slice(0, -1).map((promote, index) => {
        return promote.template === "center" ? (
          <CenterTemplate
            key={index}
            order={promote.order}
            category={promote.category}
            name={promote.name}
            desc={promote.desc}
            promotion_url={promote.promotion_url}
            products={promote.products}
            setSelectProduct={setSelectProduct}
            template={promote.template}
            viewport={viewport}
            selectedCustomVariant={selectedCustomVariant}
            setSelectedCustomVariant={setSelectedCustomVariant}
            fromName={fromName}
            setFromName={setFromName}
            toName={toName}
            setToName={setToName}
            toEmail={toEmail}
            setToEmail={setToEmail}
            toMobile={toMobile}
            setToMobile={setToMobile}
            toMessage={toMessage}
            setToMessage={setToMessage}
            pregnancy={pregnancy}
            setPregnancy={setPregnancy}
            duDate={duDate}
            setDuDate={setDuDate}
            childName={childName}
            setChildName={setChildName}
            childAge={childAge}
            setChildAge={setChildAge}
            childGender={childGender}
            setChildGender={setChildGender}
          />
        ) : (
          <NormalTemplate
            key={index}
            order={promote.order}
            category={promote.category}
            name={promote.name}
            desc={promote.desc}
            promotion_url={promote.promotion_url}
            products={promote.products}
            setSelectProduct={setSelectProduct}
            template={promote.template}
            viewport={viewport}
            selectedCustomVariant={selectedCustomVariant}
            setSelectedCustomVariant={setSelectedCustomVariant}
            fromName={fromName}
            setFromName={setFromName}
            toName={toName}
            setToName={setToName}
            toEmail={toEmail}
            setToEmail={setToEmail}
            toMobile={toMobile}
            setToMobile={setToMobile}
            toMessage={toMessage}
            setToMessage={setToMessage}
            pregnancy={pregnancy}
            setPregnancy={setPregnancy}
            duDate={duDate}
            setDuDate={setDuDate}
            childName={childName}
            setChildName={setChildName}
            childAge={childAge}
            setChildAge={setChildAge}
            childGender={childGender}
            setChildGender={setChildGender}
          />
        );
      })}
      {promotion_list.length === 1 && promotion_list[0].template === "center" ? (
        <CenterTemplate
          key={promotion_list[0].order}
          order={promotion_list[0].order}
          category={promotion_list[0].category}
          name={promotion_list[0].name}
          desc={promotion_list[0].desc}
          promotion_url={promotion_list[0].promotion_url}
          products={promotion_list[0].products}
          setSelectProduct={setSelectProduct}
          template={promotion_list[0].template}
          viewport={viewport}
          selectedCustomVariant={selectedCustomVariant}
          setSelectedCustomVariant={setSelectedCustomVariant}
          fromName={fromName}
          setFromName={setFromName}
          toName={toName}
          setToName={setToName}
          toEmail={toEmail}
          setToEmail={setToEmail}
          toMobile={toMobile}
          setToMobile={setToMobile}
          toMessage={toMessage}
          setToMessage={setToMessage}
          pregnancy={pregnancy}
          setPregnancy={setPregnancy}
          duDate={duDate}
          setDuDate={setDuDate}
          childName={childName}
          setChildName={setChildName}
          childAge={childAge}
          setChildAge={setChildAge}
          childGender={childGender}
          setChildGender={setChildGender}
        />
      ) : (
        <NormalTemplate
          key={promotion_list[0].order}
          order={promotion_list[0].order}
          category={promotion_list[0].category}
          name={promotion_list[0].name}
          desc={promotion_list[0].desc}
          promotion_url={promotion_list[0].promotion_url}
          products={promotion_list[0].products}
          setSelectProduct={setSelectProduct}
          template={promotion_list[0].template}
          viewport={viewport}
          selectedCustomVariant={selectedCustomVariant}
          setSelectedCustomVariant={setSelectedCustomVariant}
          fromName={fromName}
          setFromName={setFromName}
          toName={toName}
          setToName={setToName}
          toEmail={toEmail}
          setToEmail={setToEmail}
          toMobile={toMobile}
          setToMobile={setToMobile}
          toMessage={toMessage}
          setToMessage={setToMessage}
          pregnancy={pregnancy}
          setPregnancy={setPregnancy}
          duDate={duDate}
          setDuDate={setDuDate}
          childName={childName}
          setChildName={setChildName}
          childAge={childAge}
          setChildAge={setChildAge}
          childGender={childGender}
          setChildGender={setChildGender}
        />
      )}
      {multiBanner.length > 1 && (
        <div className="grid grid-cols-1 md:grid-cols-2 container gap-8">
          {multiBanner.slice(0, 2).map((banner, index) => (
            <div key={index} className="w-full">
              <Link href={banner.link}>
                <Image
                  src={banner.desktop_image}
                  alt="Second Banner"
                  width={980}
                  height={500}
                  quality={100}
                  className="hidden md:block"
                />
                <Image
                  src={banner.mobile_image}
                  alt="Second Banner"
                  width={1024}
                  height={442}
                  quality={100}
                  className="block md:hidden"
                />
              </Link>
            </div>
          ))}
        </div>
      )}
      {promotion_list.length > 1 && promotion_list.slice(-1).map((promote, index) => {
        return promote.template === "center" ? (
          <CenterTemplate
            key={index}
            order={promote.order}
            category={promote.category}
            name={promote.name}
            desc={promote.desc}
            promotion_url={promote.promotion_url}
            products={promote.products}
            setSelectProduct={setSelectProduct}
            template={promote.template}
            viewport={viewport}
            selectedCustomVariant={selectedCustomVariant}
            setSelectedCustomVariant={setSelectedCustomVariant}
            fromName={fromName}
            setFromName={setFromName}
            toName={toName}
            setToName={setToName}
            toEmail={toEmail}
            setToEmail={setToEmail}
            toMobile={toMobile}
            setToMobile={setToMobile}
            toMessage={toMessage}
            setToMessage={setToMessage}
            pregnancy={pregnancy}
            setPregnancy={setPregnancy}
            duDate={duDate}
            setDuDate={setDuDate}
            childName={childName}
            setChildName={setChildName}
            childAge={childAge}
            setChildAge={setChildAge}
            childGender={childGender}
            setChildGender={setChildGender}
          />
        ) : (
          <NormalTemplate
            key={index}
            order={promote.order}
            category={promote.category}
            name={promote.name}
            desc={promote.desc}
            promotion_url={promote.promotion_url}
            products={promote.products}
            setSelectProduct={setSelectProduct}
            template={promote.template}
            viewport={viewport}
            selectedCustomVariant={selectedCustomVariant}
            setSelectedCustomVariant={setSelectedCustomVariant}
            fromName={fromName}
            setFromName={setFromName}
            toName={toName}
            setToName={setToName}
            toEmail={toEmail}
            setToEmail={setToEmail}
            toMobile={toMobile}
            setToMobile={setToMobile}
            toMessage={toMessage}
            setToMessage={setToMessage}
            pregnancy={pregnancy}
            setPregnancy={setPregnancy}
            duDate={duDate}
            setDuDate={setDuDate}
            childName={childName}
            setChildName={setChildName}
            childAge={childAge}
            setChildAge={setChildAge}
            childGender={childGender}
            setChildGender={setChildGender}
          />
        );
      })}
      {bottomBanner.length > 0 && bottomBanner.map((banner, index) => (
        <div key={index} className={`w-full mt-6 md:mt-10 container ${index === bottomBanner.length - 1 ? "mb-12": ""}`}>
          <Link href={banner.link}>
            <Image
              src={banner.desktop_image}
              alt="Bottom Banner"
              width={1200}
              height={300}
              quality={100}
              className="hidden md:block"
            />
            <Image
              src={banner.mobile_image}
              alt="Bottom Banner"
              width={540}
              height={180}
              quality={100}
              className="block md:hidden"
            />
          </Link>
        </div>
      ))}
      {selectProduct !== null && (
        <AddToCart
          id={selectProduct.id}
          name={selectProduct.name}
          msrp={selectProduct.msrp}
          sales_price={selectProduct.sales_price}
          product_code={selectProduct.sku}
          qty={selectProduct.qty}
          image={selectProduct.image}
          attribute_value_list={selectProduct.attribute_value_list}
          product_variant_list={selectProduct.product_variant_list}
          special_price={selectProduct.special_price}
          brand={selectProduct.brand}
          slug={selectProduct.slug}
          style="popup"
          variant={variant}
          setVariant={setVariant}
          setShowCart={setShowCart}
          action="add"
          open={open}
          setOpen={setOpen}
          virtual_product={selectProduct.virtual_product}
          need_shipping={selectProduct.need_shipping}
          custom_variant_list={selectProduct.custom_variant_list}
          selectedCustomVariant={selectedCustomVariant}
          setSelectedCustomVariant={setSelectedCustomVariant}
          fromName={fromName}
          setFromName={setFromName}
          toName={toName}
          setToName={setToName}
          toEmail={toEmail}
          setToEmail={setToEmail}
          toMobile={toMobile}
          setToMobile={setToMobile}
          toMessage={toMessage}
          setToMessage={setToMessage}
          pregnancy={pregnancy}
          setPregnancy={setPregnancy}
          duDate={duDate}
          setDuDate={setDuDate}
          childName={childName}
          setChildName={setChildName}
          childAge={childAge}
          setChildAge={setChildAge}
          childGender={childGender}
          setChildGender={setChildGender}
          pwp_name={selectProduct.pwp_name}
          pwp={selectProduct.pwp}
          shared_sales_price={null}
          type={affiliate !== null && affiliate !== undefined ? "affiliate" : "ec"}
        />
      )}
    </>
  )
}

export default Promotions
